import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import { LeadStageType } from '@/Mapper/LeadStageType';
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('leadAgentMappingStore', [
      'lamStageIsLessThanListed',
    ]),
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
      'updateLeadStage',
    ]),
    listedUpdates() {
      return new Promise((resolve, reject) => {
        this.createCaseForListingUpdate();
        if (this.lamStageIsLessThanListed) {
          this.moveToListed()
            .then(() => {
              this.logLeadEvent(
                'Leads Management - Submit status change - Listed',
                'Single Deal Page - Post-Accepted'
              );
              this.moveLeadToListed()
                .then(() => {
                  this.createListedCall(); // How to handle errors?
                  resolve(true);
                });
            });
        } else {
          resolve(true);
        }
      });
    },
    moveToListed() {
      const data = {
        stagetypeid: LeadAgentLeadStageType.Listed,
        sourcetypeid: this.isLamOwner ? 1 : 5,
      };
      return this.updateLeadAgentStage(data);
    },
    moveLeadToListed() {
      const payload = {
        leadkey: this.lead.key,
        data: {
          leadstagetypeid: LeadStageType.Listed,
          oauserkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
          sourcetypeid: this.isLamOwner ? 1 : 5,
        },
      };
      return this.updateLeadStage(payload);
    },
    updateLeadAgentStage(data) {
      if (!data.oauserid && !!this.user) {
        data.oauserid = this.user.id;
        data.oauserkey = this.user.key;
      }
      data.sourcetypeid = this.isLamOwner ? 1 : 5;
      const payload = {
        lamid: this.lam.id,
        data,
      };
      return this.updateLeadAgentMapping(payload);
    },
    getCampaignName(campaigns) {
      if (campaigns) {
        for (let i = 0; i < campaigns.length; i += 1) {
          if (campaigns[i].id === 8) {
            return campaigns[i].callcampaigntypename;
          }
        }
      }
      return '';
    },
    createOACall(scheduledDate, inini3identity) {
      const data = {
        agentid: this.lam.agentid,
        // agentid: this.agent.id,
        assignedconsultantuserid: 0,
        callcampaigntypeid: 8,
        callcontacttypeid: 2, // Agent
        callphonetypeid: 1, // Primary
        callreasonforcalltypeid: 42,
        callstatustypeid: 1,
        calltypeid: 1,
        contactname: this.lam.agentname,
        creatorconsultantuserkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
        // creatorconsultantuserkey: this.agent.userkey,
        leadid: this.lead.id,
        phone: this.lam.agentphone && this.lam.agentphone.length > 0
          ? this.lam.agentphone
          : this.agent.phone,
        reasonforcalldetails: 'Auto task - created as moved to Listed Stage',
        scheduleddate: scheduledDate,
        inini3identity,
      };
      return this.$apiServices.oa.call.create(data);
    },
    createListedCall() {
      this.$apiServices.oa.call.getCampaigns()
        .then((campaigns) => {
          if (campaigns) {
            const campaignName = this.getCampaignName(campaigns);
            const scheduledDate = this.getScheduledDate();
            const data = {
              agentid: this.lam.agentid,
              callcampaigntypeid: 8,
              callcampaigntypename: campaignName,
              callcontacttypeid: 2, //Agent
              callphonetypeid: 1,   //Primary
              callreasonforcalltypeid: 42,
              callreasonforcalltypename: "Listed: Sold? - Auto",
              callstatustypeid: 1,
              calltypeid: 1,
              contactname: this.lam.agentname,
              creatorconsultantuserid: !!this.user && !!this.user.id? this.user.id : this.agent.userid,
              leadid: this.lead.id,
              phone: this.lam.agentphone && this.lam.agentphone.length > 0
              ? this.lam.agentphone
              : this.agent.phone,
              reasonforcalldetails: "Auto task - created as moved to Listed Stage",
              scheduleddate: scheduledDate,
              diallerscriptname: "OA Followup Calls Script",
              diallerqueuename: "OA Listing&Sold Followup Calls",
            };

            return this.$apiServices.oa.call.createDiallerCall(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getScheduledDate() {
      // create a call on the first working day after 21 days from stage change to listed
      // get date in 21 days
      const today = new Date();
      const in21days = new Date();
      in21days.setDate(today.getDate() + 21);
      if (in21days.getDay() === 6) {
        in21days.setDate(in21days.getDate() + 2);
      } else if (in21days.getDay() === 0) {
        in21days.setDate(in21days.getDate() + 1);
      }
      return `${this.convertDate(in21days)} ${this.convertTime('9am')}`;
    },
    validDate(d) {
      return d != null && !Number.isNaN(d.getTime());
    },
    convertDate(d) {
      if (!this.validDate(d)) {
        return null;
      }

      const y = d.getFullYear();
      const m = (`0${d.getMonth() + 1}`).slice(-2);
      const day = (`0${d.getDate()}`).slice(-2);
      return `${y}-${m}-${day}`;
    },
    convertTime(t) {
      // 8:30am to 8:30:00
      if (t === null || !t.match(/^\d{1,2}(:\d{1,2})?(am|pm)$/)) {
        return null;
      }

      const isPM = !!t.match(/pm/);
      let converted = t.replace(/[a-z]/g, '');

      if (!converted.match(/:/)) {
        converted += ':00';
      }
      converted += ':00';
      if (converted.length < 8) {
        converted = `0${converted}`;
      }

      if (isPM) {
        const tt = converted.split(':');
        tt[0] = +tt[0];
        if (tt[0] !== 12) {
          tt[0] += 12;
        }
        converted = tt.join(':');
      }
      return converted;
    },
  },
};